/**
 * Print-only pill / chip atom for Monthly Consultation PDF.
 */

import React from "react";
import { bodyFontFamily } from "../pdfTheme";

/**
 * Props for a small rounded label chip (priority, role, stance).
 */
export interface PdfPillProps {
  /** Visible chip text. */
  label: string;
  /** Foreground / text color (theme token). */
  color: string;
  /** Background fill color (theme token or tint). */
  bg: string;
}

/**
 * Small rounded chip with theme-driven colors.
 * Used for role labels, stance tags, and priority markers.
 */
export const PdfPill: React.FC<PdfPillProps> = ({ label, color, bg }) => {
  const safeLabel = typeof label === "string" ? label.trim() : "";
  if (safeLabel.length === 0) {
    return null;
  }

  return (
    <span
      style={{
        display: "inline-block",
        padding: "3px 10px",
        borderRadius: 999,
        fontFamily: bodyFontFamily,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        lineHeight: 1.4,
        color,
        backgroundColor: bg,
        whiteSpace: "nowrap",
      }}
    >
      {safeLabel}
    </span>
  );
};
